
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/vacances-d-ete-les-cles-pour-faire-le-bon-choix",
      function () {
        return require("private-next-pages/blog/vacances-d-ete-les-cles-pour-faire-le-bon-choix/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/vacances-d-ete-les-cles-pour-faire-le-bon-choix"])
      });
    }
  